<template>
  <div ref="totalRef" class="subpage">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" title="八字命理" :is-sub-page="true">
      <!--
      <template v-slot:rightBtn>
        <span class="btn btn-share" @click="shareClick"></span>
      </template>
      -->
    </Header>

    <div ref="contentRef" class="form-content">
      <div style="padding-bottom: 25.4%; height: 0; margin-top: 20px; margin-bottom: 70px">
        <img src="@/assets/images/backgrounds/bg-bzsz.png" alt="pic" class="bg-img"/>
      </div>
      <Form
        ref="formRef"
        :models="model"
        :formFields="fields"
        :items="items"
        btnMsg="测算"
        @submitClick="goResult"></Form>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Form from '../../components/Form'
import areaData from '@/assets/area'

const cityData = JSON.parse(JSON.stringify(areaData))
cityData.forEach(province => {
  province.children = province.cityList
  province.text = province.name
  province.children.forEach(city => {
    city.text = city.name
  })
  delete province.cityList
  delete province.children.areaList
})

const CityPicker = {
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      selected: []
    }
  },
  render (createElement) {
    return createElement('div', {
      style: {
        textAlign: 'left',
        color: this.selected.length ? '#757575' : '#cecece',
        fontSize: '14px'
      },
      on: {
        click: this.showPicker
      }
    }, this.selected.length ? this.selected.join(' ') : '请选择出生地区')
  },
  mounted () {
    this.picker = this.$createCascadePicker({
      title: '省市地区',
      data: cityData,
      selectedIndex: this.value,
      onSelect: this.selectHandler
    })
  },
  methods: {
    showPicker () {
      this.picker.show()
    },
    selectHandler (selectedVal, selectedIndex, selectedTxt) {
      this.selected = selectedTxt
      this.$emit('input', this.selected)
    }
  }
}

export default {
  name: 'SiZhu',
  components: {
    Header,
    Form
  },
  data () {
    return {
      computedHeight: 0,
      model: {
        birthdayType: '', // 日期类型 0阳历、1阴历
        birthday: '', // 出生日期
        birthCity: [], // 出生地点
        name: '', // 姓名
        gender: '', // 性别
        userValue: ''
      },
      items: ['radio', 'date', 'input', 'input', 'radio', 'button', 'userradio'],
      fields: [
        {
          type: 'radio-group',
          modelKey: 'birthdayType',
          label: '日期类型',
          props: {
            options: ['阳历', '阴历'],
            horizontal: true,
            hollowStyle: true
          },
          rules: {
            required: true
          },
          messages: {
            required: '请选择日期类型'
          }
        },
        {
          type: 'input',
          modelKey: 'birthday',
          label: '出生日期',
          props: {
            placeholder: '请选择出生日期',
            readonly: true
          },
          rules: {
            required: true
          },
          messages: {
            required: '请选择出生日期'
          }
        },
        {
          component: CityPicker,
          modelKey: 'birthCity',
          label: '出生地点',
          messages: {
            required: '请选择出生地点'
          }
        },
        {
          type: 'input',
          modelKey: 'name',
          label: '姓名',
          props: {
            placeholder: '请输入姓名'
          }
        },
        {
          type: 'radio-group',
          modelKey: 'gender',
          label: '性别',
          props: {
            options: ['男', '女'],
            horizontal: true,
            hollowStyle: true
          },
          rules: {
            required: true
          },
          messages: {
            required: '请选择性别'
          }
        },
        {
          type: null
        },
        {
          type: 'radio-group',
          modelKey: 'userValue',
          props: {
            options: ['我已阅读并同意《用户隐私协议》'],
            horizontal: true,
            hollowStyle: true
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  mounted () {
    document.title = '八字命理'
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }

    this.$nextTick(() => {
      const navBarHeight = this.$refs.navBarRef ? this.$refs.navBarRef.$el.clientHeight : 0
      this.$refs.contentRef.style.height = (this.$refs.totalRef.clientHeight - navBarHeight) + 'px'
    })
  },
  methods: {
    goResult () {
      this.$router.push({
        path: 'sizhuResult',
        query: {
          platform: this.$route.query.platform,
          data: JSON.stringify(this.model)
        }
      })
    },
    shareClick () {
      this.$dfzhJsBridge.share({
        url: process.env.VUE_APP_SHARE_URL + '/sizhu?protocol=true',
        title: '东方智汇八字命理',
        description: ' '
      })
    }
  }
}
</script>

<style lang="stylus" scoped src="@/style/form.styl"></style>

<style lang="stylus" scoped>
.subpage
  background url("~@/assets/images/backgrounds/bg.png") no-repeat center
  background-size 100% 100%
</style>

<style lang="stylus">
body
  background-color #EFE9E0
</style>
